export const Menuitems = [
  {
    title: "Home",
    url: "/",
    clName: "nav-links",
    icon: "fa-sharp fa-solid fa-house-user",
  },
  {
    title: "About",
    url: "/about",
    clName: "nav-links",
    icon: "fa-sharp fa-solid fa-circle-info",
  },
  {
    title: "Portfolio",
    url: "/portfolio",
    clName: "nav-links",
    icon: "fa-sharp fa-solid fa-briefcase",
  },
  {
    title: "Contact",
    url: "/contact",
    clName: "nav-links",
    icon: "fa-sharp fa-solid fa-address-book",
  },
];
